import React from 'react';
import { PrinterFill } from 'react-bootstrap-icons';
import { useGlobalLoading } from '../../../../context';
import { pdfOptions } from '../../../components/ProfileBar/utils/pdfOptions';
import { generatePatientPDF } from '../utils/printUtils';

interface TimelinePrintBarProps {
  className?: string;
  label?: string;
  disabled?: boolean;
  onPrint?: () => Promise<void> | void;
}

const TimelinePrintBar = ({
  className = 'd-flex flex-row align-items-center justify-content-end gap-2 print',
  label = 'Print',
  disabled = false,
  onPrint,
}: TimelinePrintBarProps) => {
  const { startLoading, stopLoading } = useGlobalLoading();

  const handleClick = async () => {
    if (disabled) return;
    if (onPrint) {
      await onPrint();
      return;
    }
    startLoading('Preparing document for printing');
    await generatePatientPDF(pdfOptions);
    stopLoading();
  };

  return (
    <div className={className}>
      <button onClick={handleClick} disabled={disabled}>
        <span
          className="font-12 font-weight-400 labelSimple"
          style={{ marginRight: '5px' }}
        >
          {label}
        </span>
        <PrinterFill color="#6a7277" size={14} />
      </button>
    </div>
  );
};

export default TimelinePrintBar;
